// Validação de CPF: 11 dígitos + dois dígitos verificadores.
// Rejeita sequências iguais (111.111.111-11 etc.), que passam na conta
// dos dígitos verificadores mas são inválidas por convenção da Receita.
export function isValidCPF(value) {
  if (!value) return false
  const digits = String(value).replace(/\D/g, '')
  if (digits.length !== 11) return false
  if (/^(\d)\1{10}$/.test(digits)) return false

  let sum = 0
  for (let i = 0; i < 9; i++) {
    sum += parseInt(digits[i], 10) * (10 - i)
  }
  let check = 11 - (sum % 11)
  if (check >= 10) check = 0
  if (check !== parseInt(digits[9], 10)) return false

  sum = 0
  for (let i = 0; i < 10; i++) {
    sum += parseInt(digits[i], 10) * (11 - i)
  }
  check = 11 - (sum % 11)
  if (check >= 10) check = 0
  if (check !== parseInt(digits[10], 10)) return false

  return true
}
